import { Data } from './../data/data';
import { ModifierBuilder } from './modifier-builder';
import { OrderItem } from '../data/order-item';
import { Category } from '../data/category';
import { ItemGroup } from '../data/item-group';
import { Item } from '../data/item';
/**
 * a temporary order item manager
 * **/
var OrderItemBuilder = /** @class */ (function () {
    function OrderItemBuilder(store) {
        this.groups = [];
        //combo: boolean = false;
        this.items = [];
        this.qmap = [];
        this.store = store;
    }
    OrderItemBuilder.prototype.clone = function () {
        var builder = new OrderItemBuilder(this.store);
        builder.category = this.category;
        //builder.combo = this.combo;
        //builder.mods = this.mods;
        this.copyTo(builder);
        return builder;
    };
    OrderItemBuilder.prototype.copyTo = function (another) {
        var groups = [];
        this.groups.forEach(function (group, i) {
            if (group) {
                groups[i] = Data.toData(ItemGroup, JSON.parse(JSON.stringify(group)));
            }
        });
        another.groups = groups;
        another.items = Data.toDataArray(Item, JSON.parse(JSON.stringify(this.items)));
        another.qmap = JSON.parse(JSON.stringify(this.qmap));
    };
    OrderItemBuilder.test = function (store) {
        console.log("testing builder", store);
        var b = new OrderItemBuilder(store);
        var cat = store.categories[0];
        var ig = cat.groups[0];
        var item = ig.items[0];
        var mig = item.mgroups[0];
        var mod = mig.items[0];
        var ig2 = item.groups[0];
        var item2 = ig2.items[0];
        b.setCategory(cat);
        b.setItem(ig, item, 0);
        //b.setModItem(0, mig, mod, 0);
        b.setItem(ig2, item2, 2);
        var oi = b.build();
        console.log("oi", oi);
        var mb = new ModifierBuilder(store, oi);
        mb.setMod(item, mig, mod, 2);
        var quan = mb.getQuantity(item, mig, mod);
        console.log("quantity", quan);
        var oi2 = mb.build();
        console.log("oi2", oi2);
        var flattens = OrderItem.getFlattenItems(oi2, true);
        console.log(flattens);
    };
    OrderItemBuilder.createEmptyCategory = function (category) {
        var cat = new Category();
        cat.id = category.id;
        cat.name = category.name;
        cat.type = category.type;
        cat.openings = category.openings;
        cat.cgroupId = category.cgroupId;
        cat.departmentId = category.departmentId;
        return cat;
    };
    OrderItemBuilder.prototype.findItems = function (index) {
        if (index < 0 || index >= this.groups.length)
            return [];
        var g = this.groups[index];
        if (!g)
            return [];
        return g.items;
    };
    OrderItemBuilder.prototype.build = function () {
        var oi = new OrderItem();
        if (!this.category) {
            console.log("ERROR! Category must be set!");
            return;
        }
        oi.category = OrderItemBuilder.createEmptyCategory(this.category);
        oi.categoryId = this.category.id;
        oi.categoryType = this.category.type;
        oi.cgroupId = this.category.cgroupId;
        oi.departmentId = this.category.departmentId;
        if (!this.store || !this.store.id) {
            console.warn("store is empty! ", this);
        }
        oi.storeId = this.store.id;
        // console.log("builder.groups:", this.groups);
        oi.groups = [];
        for (var _i = 0, _a = this.groups; _i < _a.length; _i++) {
            var ig = _a[_i];
            if (ig) {
                oi.groups.push(ig);
            }
        }
        OrderItem.flattenItems(oi);
        //console.log("flatten", oi.items);
        var markerItem = null;
        var points = 0;
        for (var _b = 0, _c = oi.items; _b < _c.length; _b++) {
            var item = _c[_b];
            if (item.modifiable)
                oi.modifiable = true;
            if (item.marker)
                markerItem = item;
            if (item.points && item.points > 0)
                points += item.points;
        }
        oi.points = points;
        if (oi.items.length > 0 && oi.items[0].combo) {
            oi.combo = true;
        }
        oi.takeout = false;
        if (markerItem)
            oi.takeout = markerItem.marker == "takeaway";
        this.items = oi.items;
        this.orderItem = oi;
        return oi;
    };
    OrderItemBuilder.prototype.setCategory = function (cat) {
        this.category = cat;
    };
    OrderItemBuilder.prototype.setItem = function (group, item, index, quantity, ignoreAddTime, includeMod) {
        if (quantity === void 0) { quantity = 1; }
        if (ignoreAddTime === void 0) { ignoreAddTime = true; }
        if (includeMod === void 0) { includeMod = false; }
        this.plusItem(group, item, index, quantity, ignoreAddTime, includeMod);
    };
    OrderItemBuilder.prototype.clearItems = function (index) {
        this.groups[index] = null;
        this.qmap[index] = {};
        //console.log("cleared index " + index, this.groups);
    };
    OrderItemBuilder.prototype.plusItem = function (group, item, index, fixed, ignoreAddTime, includeMod) {
        if (fixed === void 0) { fixed = 0; }
        if (ignoreAddTime === void 0) { ignoreAddTime = true; }
        if (includeMod === void 0) { includeMod = false; }
        var isModifiable = this.checkIsModifiable(group, item);
        item.modifiable = isModifiable;
        console.log("adding " + item.name + " to index " + index, item);
        var ig = this.groups[index];
        if (!ig) {
            ig = OrderItemBuilder.cloneIG(group);
            this.groups[index] = ig;
        }
        var items = ig.items;
        if (!items) {
            items = [];
            ig.items = items;
        }
        var isModifiable = this.checkIsModifiable(group, item);
        var savedItem = null;
        if (!isModifiable) {
            for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
                var exist = items_1[_i];
                if (exist.id == item.id) {
                    savedItem = exist;
                }
            }
        }
        //NOT SEPARATE SUB-ITEMS
        //find the existing item
        /*var savedItem = null;
        for (let exist of items) {
            if (exist.id == item.id) {
                savedItem = exist;
            }
        }

        //if none found, add it
        if (!savedItem) {

            savedItem = OrderItemBuilder.cloneItem(item, includeMod);
            savedItem.quantity = 0;
            items.push(savedItem);
        }*/
        //SEPARATE SUB_ITEMS
        if (!savedItem || isModifiable) {
            savedItem = OrderItemBuilder.cloneItem(item, includeMod);
            savedItem.quantity = 0;
            if (!ignoreAddTime)
                savedItem.addTime = item.addTime;
            items.push(savedItem);
        }
        //SEPARATE SUB_ITEMS -- END
        if (fixed == 0) {
            savedItem.quantity = savedItem.quantity + 1;
        }
        else {
            savedItem.quantity = fixed;
        }
        this.saveQuantity(index, item.id, savedItem.quantity, isModifiable);
    };
    OrderItemBuilder.prototype.checkIsModifiable = function (group, item) {
        // var originsItemGroup = this.store.menu['gmap'][group.id];
        // for(let originsItem of originsItemGroup.items)
        // {
        //     if(originsItem.id == item.id)
        //     {
        //         var orimgroups = originsItem.mgroups;
        //         if(orimgroups && orimgroups.length > 0){
        //             isModifiable =  true;
        //             break;
        //         }
        //     }
        // }
        var imap = this.store.menu['imap'];
        var realItem = item;
        if (imap && item.id in imap) {
            realItem = imap[item.id];
        }
        return Item.isModifiable(realItem);
    };
    OrderItemBuilder.prototype.minusItem = function (group, item, index, ignoreAddTime) {
        if (ignoreAddTime === void 0) { ignoreAddTime = true; }
        var ig = this.groups[index];
        if (!ig)
            return;
        var items = ig.items;
        if (!items) {
            return;
        }
        //find the existing item
        //let isModifiable = item.mgroups && item.mgroups.length > 0;
        var isModifiable = this.checkIsModifiable(group, item);
        var savedItem = null;
        var itemIndex = 0;
        for (var i = items.length - 1; i >= 0; i--) {
            var exist = items[i];
            if (exist.id == item.id) {
                if (!ignoreAddTime && exist.addTime != item.addTime)
                    continue;
                savedItem = exist;
                itemIndex = i;
                break;
            }
            //itemIndex++;
        }
        if (!savedItem)
            return;
        var n = savedItem.quantity - 1;
        savedItem.quantity = n;
        //this.saveQuantity(index, item.id, n);
        this.saveQuantity(index, item.id, -1, isModifiable);
        if (n <= 0) {
            items.splice(itemIndex, 1);
        }
    };
    OrderItemBuilder.prototype.isCleared = function (igIndex) {
        return this.groups[igIndex] == null && this.qmap[igIndex] != null;
    };
    OrderItemBuilder.prototype.noNeedSelected = function (igIndex, editMode) {
        // console.log("noNeedSelected", this.groups);
        var g = this.groups[igIndex];
        if (editMode && !g)
            return true;
        if (!editMode && typeof g !== 'undefined' && g == null)
            return true;
        return false;
    };
    OrderItemBuilder.prototype.deleteItem = function (igIndex) {
        this.groups[igIndex] = null;
        this.qmap[igIndex] = null;
    };
    OrderItemBuilder.prototype.isModifiable = function (groups, igIndex) {
        var _this = this;
        if (igIndex === void 0) { igIndex = null; }
        if (igIndex == null) {
            return this.groups.some(function (group, i) { return _this.isModifiable(groups, i); });
        }
        var ig = groups[igIndex];
        if (!ig) {
            console.log("item group not found!");
            return false;
        }
        var items = ig.items;
        return items.some(function (item) { return Item.isModifiable(item); });
    };
    OrderItemBuilder.prototype.setModItem = function (igIndex, mgroup, mitem, index) {
        var ig = this.groups[igIndex];
        if (!ig) {
            console.log("ERROR! Cannot add modifier to non existing IG position", igIndex);
            return;
        }
        var item = ig.items[0];
        var mig = OrderItemBuilder.cloneIG(mgroup);
        var mod = OrderItemBuilder.cloneItem(mitem);
        mod.quantity = 1;
        mig.items = [mod];
        if (!item.mgroups) {
            item.mgroups = [];
        }
        item.mgroups[index] = mig;
    };
    OrderItemBuilder.cloneIG = function (from) {
        var ig = new ItemGroup();
        ig.id = from.id;
        ig.items = [];
        ig.name = from.name;
        ig.backendId = from.backendId;
        ig.max = from.max;
        ig.min = from.min;
        ig.modifier = from.modifier;
        //ig.optional = from.optional;
        ig.repeat = from.repeat;
        ig.skippable = from.skippable;
        ig.tags = from.tags;
        ig.printers = from.printers;
        ig.defaultId = from.defaultId;
        ig.pagerMode = from.pagerMode;
        return ig;
    };
    OrderItemBuilder.cloneItem = function (from, cloneModifiers) {
        var _this = this;
        if (cloneModifiers === void 0) { cloneModifiers = false; }
        var item = new Item();
        item.addTime += from.addTime;
        item.id = from.id;
        item.name = from.name;
        item.backendName = from.backendName;
        item.price = from.price;
        item.price0 = from.price0;
        item.price1 = from.price1;
        item.price2 = from.price2;
        item.handling = from.handling;
        item.discountedPrice = from.discountedPrice;
        if (!cloneModifiers || from.mgroups == null) {
            item.mgroups = null;
        }
        else {
            var mgroups_1 = [];
            from.mgroups.forEach(function (mgroup) {
                var mg = _this.cloneIG(mgroup);
                mgroup.items.forEach(function (mitem) {
                    var i = _this.cloneItem(mitem, false);
                    mg.items.push(i);
                });
                mgroups_1.push(mg);
            });
            item.mgroups = mgroups_1;
        }
        item.quantity = from.quantity;
        item.backendId = from.backendId;
        item.printName = from.printName;
        item.images = from.images;
        item.tags = from.tags;
        item.modifiable = from.modifiable;
        item.combo = from.combo;
        item.printers = from.printers;
        item.extra = from.extra;
        item.pgroupId = from.pgroupId;
        item.marker = from.marker;
        item.points = from.points;
        item.discountable = from.discountable;
        item.comboId = from.comboId;
        item.comboName = from.comboName;
        item.taxGroup = from.taxGroup;
        item.packing = from.packing;
        item.discountedId = from.discountedId;
        return item;
    };
    OrderItemBuilder.cloneOrderItem = function (from, cloneModifiers) {
        if (cloneModifiers === void 0) { cloneModifiers = false; }
        var oi = new OrderItem();
        oi.total = from.total;
        var groups = [];
        for (var _i = 0, _a = from.groups; _i < _a.length; _i++) {
            var ig = _a[_i];
            var items = [];
            for (var _b = 0, _c = ig.items; _b < _c.length; _b++) {
                var i = _c[_b];
                items.push(this.cloneItem(i, cloneModifiers));
            }
            var newIg = this.cloneIG(ig);
            newIg.items = items;
            groups.push(newIg);
        }
        oi.groups = groups;
        oi.categoryId = from.categoryId;
        oi.category = from.category;
        oi.quantity = from.quantity;
        oi.combo = from.combo;
        oi.modifiable = from.modifiable;
        oi.storeId = from.storeId;
        oi.handling = from.handling;
        oi.discount = from.discount;
        oi.discounts = from.discounts;
        oi.takeout = from.takeout;
        oi.barcode = from.barcode;
        oi.message = from.message;
        oi.grandTotal = from.grandTotal;
        oi.points = from.points;
        oi.packing = from.packing;
        return oi;
    };
    //subgroups (does not include main group) is used to find the proper position of the item
    OrderItemBuilder.prototype.transferSubitems = function (oi, subgroups) {
        var gids = subgroups.map(function (g) { return g.id; });
        for (var _i = 0, _a = oi.groups.slice(1); _i < _a.length; _i++) {
            var ig = _a[_i];
            var index = gids.indexOf(ig.id);
            for (var _b = 0, _c = ig.items; _b < _c.length; _b++) {
                var item = _c[_b];
                this.setItem(ig, item, index + 1, item.quantity, false, true);
            }
        }
    };
    OrderItemBuilder.prototype.transferAllItems = function (oi, subgroups) {
        var gids = subgroups.map(function (g) { return g.id; });
        for (var _i = 0, _a = oi.groups; _i < _a.length; _i++) {
            var ig = _a[_i];
            var index = gids.indexOf(ig.id);
            for (var _b = 0, _c = ig.items; _b < _c.length; _b++) {
                var item = _c[_b];
                this.setItem(ig, item, index + 1, item.quantity, false, true);
            }
        }
    };
    OrderItemBuilder.prototype.findOriwithStore = function (oi, store) {
        console.log(store);
        var ocat = store.menu['cmap'][oi.categoryId];
        var gmap = store.menu['gmap'];
        var oigs = ocat ? ocat.groups : [gmap[oi.categoryId]];
        ocat = ocat ? ocat : oi.category;
        var mainItem = oi.groups[0].items[0];
        var oig = gmap[oi.groups[0].id];
        var oitem = oig.items.filter(function (item) { return item.id == mainItem.id; })[0];
        this.category = ocat;
        console.log("origins", ocat, oigs, oitem);
        return { category: ocat, groups: oigs, item: oitem };
    };
    OrderItemBuilder.prototype.findOrigins = function (oi) {
        var ocat = this.store.menu['cmap'][oi.categoryId];
        var gmap = this.store.menu['gmap'];
        var oigs = ocat ? ocat.groups : [gmap[oi.categoryId]];
        ocat = ocat ? ocat : oi.category;
        var mainItem = oi.groups[0].items[0];
        var oig = gmap[oi.groups[0].id];
        var oitem = oig.items.filter(function (item) { return item.id == mainItem.id; })[0];
        this.category = ocat;
        return { category: ocat, groups: oigs, item: oitem };
    };
    OrderItemBuilder.prototype.saveQuantity = function (igIndex, itemId, n, isModifiable) {
        if (isModifiable === void 0) { isModifiable = false; }
        var map = this.qmap[igIndex];
        if (!map) {
            map = {};
            this.qmap[igIndex] = map;
            map[itemId] = n > 0 ? n : 0;
        }
        else {
            if (isNaN(map[itemId]))
                map[itemId] = 0;
            if (n > 0) {
                map[itemId] = isModifiable ? map[itemId] + n : n;
            }
            else {
                map[itemId] = map[itemId] + n;
            }
            if (map[itemId] < 0)
                map[itemId] = 0;
        }
        //map[itemId] = n;
    };
    OrderItemBuilder.prototype.getQuantity = function (itemId) {
        var total = 0;
        for (var i = 0; i < this.groups.length; i++) {
            total += this.getQuantityInGroup(i, itemId);
        }
    };
    OrderItemBuilder.prototype.getQuantityInGroup = function (igIndex, itemId) {
        var map = this.qmap[igIndex];
        if (!map)
            return 0;
        var n = map[itemId];
        if (!n)
            return 0;
        return n;
    };
    OrderItemBuilder.prototype.getSelectedItems = function (igIndex, filterZeroItem) {
        if (filterZeroItem === void 0) { filterZeroItem = false; }
        var map = this.qmap[igIndex];
        if (!map)
            return [];
        if (filterZeroItem) {
            var tmpMap = {};
            for (var key in map) {
                if (map[key] > 0) {
                    tmpMap[key] = map[key];
                }
            }
            return Object.keys(tmpMap);
        }
        return Object.keys(map);
    };
    //get the number of selected choices in that group
    OrderItemBuilder.prototype.getChoices = function (igIndex) {
        var ig = this.groups[igIndex];
        if (!ig)
            return 0;
        var items = ig.items;
        if (!items)
            return 0;
        var choices = 0;
        items.forEach(function (i) {
            choices += i.quantity;
        });
        return choices;
    };
    return OrderItemBuilder;
}());
export { OrderItemBuilder };
//# sourceMappingURL=orderitem-builder.js.map